export enum EDatePickerViewType {
	INPUT = 'input',
	BUTTON = 'button',
	POPOVER = 'popover',
	FILTER = 'filter',
}

export enum EChipStatus {
	ACTIVE = 'active',
	PAID = 'paid',
	ENDED = 'ended',
	UNPAID = 'unpaid',
	CANCELLED = 'cancelled',
	SCHEDULED = 'scheduled',
	FAILED = 'failed',
	DRAFT = 'draft',
	PENDING = 'pending',
	PAUSED = 'paused',
	COMPLETED = 'completed',
	ARCHIVED = 'archived',
}
